import { Component, inject, OnDestroy, OnInit, signal } from '@angular/core';
import { I18nModule } from '@spartacus/core';
import { ICON_TYPE, IconModule } from '@spartacus/storefront';
import { MakeAPaymentService } from '../../../custom-make-a-payment/make-a-payment.service';
import { B2bUserService } from '../../services/b2b-user.service';
import { Observable, Subscription, switchMap } from 'rxjs';
import { toObservable } from '@angular/core/rxjs-interop';
import { filter, map, tap } from 'rxjs/operators';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'sanofi-past-due-invoices-banner',
  standalone: true,
  imports: [
    I18nModule,
    IconModule,
    RouterLink,
  ],
  templateUrl: './past-due-invoices-banner.component.html',
})
export class PastDueInvoicesBannerComponent implements OnInit, OnDestroy {
  private readonly paymentService = inject(MakeAPaymentService);
  private readonly b2bUserService = inject(B2bUserService);

  protected readonly iconTypes = ICON_TYPE;
  private readonly $b2bUnit: Observable<any>;
  hasPastDueInvoice = signal(false);
  visible = signal(true);
  private userSub: Subscription;

  constructor() {
    this.$b2bUnit = toObservable(this.b2bUserService.b2bUser);
  }

  ngOnDestroy(): void {
    this.userSub?.unsubscribe();
  }

  ngOnInit(): void {
    this.userSub = this.$b2bUnit
      .pipe(
        tap(() => {
          this.visible.set(true);
          this.hasPastDueInvoice.set(false);
        }),
        filter(Boolean),
        switchMap(b2bUser => {
          return this.paymentService.getCachedInvoices({
            accountId: b2bUser.uid,
            fields: 'DEFAULT',
          });
        }),
        map(openInvoicesResponse => openInvoicesResponse?.hasPastDueInvoice)
      )
      .subscribe(hasPastDueInvoice => {
        this.hasPastDueInvoice.set(hasPastDueInvoice);
      });
  }
}
